
import { Component, Vue, Watch } from 'vue-property-decorator'
import { GetWhiteList, UpdateWhiteList } from '@/api/admin/permission'
@Component
export default class adminRole extends Vue {
    name = 'userAdmin_whiteList'
    GetWhiteList() {
        GetWhiteList({}).then((res) => {
            // this.table.total = res._param.total || 0;
            this.table.data = res._param.data || ''
        })
    }
    table = {
        data: ''
    }
    limitchange() {}
    pagechange() {}
    //创建角色

    // @Watch('table.form.show')
    // updateResize() {
    //     if (!this.table.form.show) {
    //         (this.$refs[this.table.form.ref] as any).resetFields();
    //     }
    // }
    refres() {
        this.GetWhiteList()
    }

    UpdateWhiteList() {
        if (this.table.data) {
            UpdateWhiteList({ data: this.table.data }).then((res) => {
                this.GetWhiteList()
            })
        }
    }
    // DelRoleType(id) {
    //     DelRoleType({ id }).then((res) => {
    //         this.GetWhiteList();
    //     });
    // }
    created() {
        this.GetWhiteList()
    }

    mounted() {}
}
